import gsap from "gsap";

export default function initDidYouKnowBlocks() {
  document.querySelectorAll(".did-you-know-block").forEach((block) => {
    const wraps = Array.from(block.querySelectorAll(".slider .slider-wrap"));
    if (!wraps.length) return;

    const wrapStates = wraps.map((wrap) => {
      const slides = Array.from(wrap.querySelectorAll(".slide"));
      gsap.set(slides, { xPercent: 100, zIndex: 0 });
      if (slides[0]) gsap.set(slides[0], { xPercent: 0, zIndex: 1 });
      return { wrap, slides, zTop: 1 };
    });

    const contentSlides = Array.from(
      block.querySelectorAll(".slider-content .slide")
    );
    let contentIndex = 0;

    if (contentSlides.length) {
      gsap.set(contentSlides, { autoAlpha: 0, yPercent: 2 });
      gsap.set(contentSlides[0], { autoAlpha: 1, yPercent: 0 });
      contentSlides.forEach((el, i) => el.setAttribute("aria-hidden", i === 0 ? "false" : "true"));
    }

    const nextBtn = block.querySelector(".next");
    const STAGGER = 0.1;
    const IMG_DURATION = 1;
    const CONTENT_OUT = 0.5;
    const CONTENT_IN = 1;
    let isAnimating = false;

    function normalizeZ(state) {
      state.slides.forEach((el) => {
        const visible = Math.round(gsap.getProperty(el, "xPercent")) === 0;
        gsap.set(el, { zIndex: visible ? 2 : 1 });
      });
      state.zTop = 2;
    }

    function goNext() {
		  if (isAnimating) return;
		  isAnimating = true;

		  const CONTENT_IN_DELAY = 0.4;
		  let maxEnd = 0;

		  // === CONTENT ===
		  if (contentSlides.length) {
		    const currentEl = contentSlides[contentIndex];
		    const nextContentIndex = (contentIndex + 1) % contentSlides.length;
		    const nextEl = contentSlides[nextContentIndex];

		    gsap.set(nextEl, { autoAlpha: 0, yPercent: 2 });

		    // out
		    gsap.to(currentEl, {
		      duration: CONTENT_OUT,
		      autoAlpha: 0,
		      yPercent: 2,
		      ease: "power2.out",
		      overwrite: true,
		      onComplete: () => currentEl.setAttribute("aria-hidden", "true"),
		    });
		    maxEnd = Math.max(maxEnd, CONTENT_OUT);

		    // in 
		    gsap.to(nextEl, {
		      duration: CONTENT_IN,
		      delay: CONTENT_IN_DELAY,
		      autoAlpha: 1,
		      yPercent: 0,
		      ease: "power3.out",
		      overwrite: true,
		      onStart: () => nextEl.setAttribute("aria-hidden", "false"),
		    });
		    maxEnd = Math.max(maxEnd, CONTENT_IN_DELAY + CONTENT_IN);

		    contentIndex = nextContentIndex;
		  }

		  // === IMAGES (cover + stagger) ===
		  wrapStates.forEach((state, i) => {
		    const { slides } = state;
		    if (!slides.length) return;

		    let currentIndex = slides.findIndex(
		      (el) => Math.round(gsap.getProperty(el, "xPercent")) === 0
		    );
		    if (currentIndex < 0) currentIndex = 0;

		    const nextIndex = (currentIndex + 1) % slides.length;
		    const currentEl = slides[currentIndex];
		    const nextEl = slides[nextIndex];

		    gsap.set(nextEl, { xPercent: 100 });

		    state.zTop += 1;
		    if (state.zTop > 1000) normalizeZ(state);
		    gsap.set(nextEl, { zIndex: state.zTop });

		    const delay = 0 + i * STAGGER;

		    gsap.to(nextEl, {
		      duration: IMG_DURATION,
		      delay,
		      xPercent: 0,
		      ease: "power3.inOut",
		      lazy: false, 
		      overwrite: true,
		      onComplete: () => gsap.set(currentEl, { xPercent: 100 }),
		    });

		    maxEnd = Math.max(maxEnd, delay + IMG_DURATION);
		  });

		  gsap.delayedCall(maxEnd, () => { isAnimating = false; });
		}


    nextBtn?.addEventListener("click", goNext);
  });
}